export var BOND_DEFINITION_KEY = 'bondDefinition';
export var BOND_VARIATION_KEY = 'bondVariation';
export var BOND_SALE_KEY = 'bondSale';
export var BOND_DEFAULT_KEY = 'bondDefault';
export var BOND_CURRENCY_RISK_KEY = 'bondCurrencyRisk';
